import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Location } from '@angular/common';

import { GtmService } from './gtm.service';
import { getWindow } from './helper.service';
@Injectable()
export class RoutingStateService {
  private history: string[] = [];
  private location: Location;

  constructor(private router: Router, location: Location, private gtmService: GtmService) {
    this.location = location;
  }

  public loadRouting(): void {

    this.router.events.subscribe({
      next: (event) => {
        if (event instanceof NavigationEnd) {
          this.gtmService.triggerEvent('page', { pageName: event.url });
        }
      },
      error: (error) => console.error(`RoutingStateService: router events stream error: ${error}`)
    });
  }

  public getHistory(): string[] {
    return this.history;
  }

  public getPreviousUrl(): string {
    return this.history[this.history.length - 2] || '/';
  }

  public getHostName(): string {
    const window = getWindow();
    const hostName = window.location.hostname;
    if (hostName.toLowerCase().includes('localhost')) {
      return `${hostName}:${window.location.port}`;
    }
    return hostName;
  }
}
